import axios from 'axios'

const state = {
	list: [],
};

const mutations = {
	SET_LIST: (state, list) => {
		state.list = list;
	},
}

const options = {
	headers: {
		'Accept': 'application/vnd.api+json',
		'Content-Type': 'application/vnd.api+json',
	}
};

const actions = {

	getDevices(context, payload) {
		return axios.get(process.env.VUE_APP_API_BASE_URL + '/devices/' + payload.id)
			.then((response) => {
				return response
			})
	},

	getDevicesNeedProducts(context, payload) {
		return axios.get(process.env.VUE_APP_API_BASE_URL + '/devices/' + payload.siteId + '/products')
			.then((response) => {
				return response
			})
	},

	getDeviceTypes() {
		return axios.get(process.env.VUE_APP_API_BASE_URL + '/device_types')
			.then((response) => {
				return response
			})
	},

    fetchAllDeviceTypes() {
		return axios.get(process.env.VUE_APP_API_BASE_URL + '/device_types/fetch/all')
			.then((response) => {
				return response
			})
	},

	addDevice(context, payload) {
		return axios.post(process.env.VUE_APP_API_BASE_URL+'/devices/' + payload.id, { id: payload.id, devices: payload.devices }, options)
			.then((response) => {
				return response
			})
	},

	updateDevices(context, payload) {
		return axios.put(process.env.VUE_APP_API_BASE_URL+'/devices', { id: payload.id, devices: payload.devices }, options)
			.then((response) => {
				return response
			})
	},

	updateDeviceGroupId(context, payload) {
		return axios.put(process.env.VUE_APP_API_BASE_URL+'/devices/' + payload.id, { id: payload.id, idGroup: payload.idGroup }, options)
			.then((response) => {
				return response
			})
	},

	deleteDeviceProduct(context, payload) {
		return axios.put(process.env.VUE_APP_API_BASE_URL+'/devices/' + payload.deviceId + '/delete_product', payload, options)
			.then((response) => {
				return response
			})
	},

	updateDevicePlanPositions(context, payload) {
		return axios.put(process.env.VUE_APP_API_BASE_URL+'/devices/' + payload.deviceId + '/positions', payload, options)
			.then((response) => {
				return response
			})
	},

	updateDevicePlanInfos(context, payload) {
		return axios.put(process.env.VUE_APP_API_BASE_URL+'/devices/' + payload.deviceId + '/infos', payload, options)
			.then((response) => {
				return response
			})
	},

	removeDeviceFromPlan(context, payload) {
		return axios.put(process.env.VUE_APP_API_BASE_URL+'/devices/' + payload.deviceId + '/remove', null, options)
			.then((response) => {
				return response
			})
	},

	deleteDevice(context, payload) {
		return axios.delete(process.env.VUE_APP_API_BASE_URL+'/devices/' + payload.id)
			.then((response) => {
				return response
			})
	},

}

const getters = {
	list: state => state.list,
};

const devices = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};

export default devices;
